module.exports = __webpack_public_path__ + "img/businessOpportunity.1fa9a483.png";